<nav mat-tab-nav-bar>
  @for (institutionLink of institutionLinks; track institutionLink) {
    <button mat-tab-link
      [routerLink]="institutionLink.url"
      routerLinkActive="mdc-tab--active"
      [active]="isRouteActive(institutionLink.url)"
      appAriaTitle>
      {{institutionLink.label | translate}}
    </button>
  }
</nav>